export default __webpack_public_path__ + "static/media/bloom-portrait.396d773e.jpg";